export { AlertComponent } from './alert.component';
export { AlertModule } from './alert.module';
export { AlertConfig } from './alert.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/alert/index.js
// module id = 232
// module chunks = 3